import React from 'react'

const Termdata = ({ frmdata }) => {
    return (
        <>
            {frmdata.terms} &nbsp; <a href={frmdata.termurl} target="_blank">{frmdata.termtxt}</a> and  <a href={frmdata.privacyurl} target="_blank">{frmdata.privacytxt}</a>
        </>
    )
}

export default Termdata